<!-- todo At some point use for address dropdown to make searched terms bold in the select -->
<template>
    <div>
        <template
            v-for="(segment, index) in highlightedSegments"
            :key="index"
        >
            <strong v-if="segment.isBold">{{ segment.text }}</strong>
            <span v-else>{{ segment.text }}</span>
        </template>
    </div>
</template>

<script setup>
const props = defineProps({
    matchedSubStrings: {
        type: Array,
        default: () => [],
    },
    text: {
        type: String,
        required: false,
        default: null,
    },
});

const highlightedSegments = computed(() => {
    const text = props.text ?? '';

    if (!text) return [];

    const terms = [...props.matchedSubStrings].sort((a, b) => a.offset - b.offset);
    const segments = [];

    let cursor = 0;

    terms.forEach((term) => {
        const start = Math.max(term.offset, 0);
        const end = Math.min(start + term.length, text.length);

        if (start > cursor) {
            segments.push({
                text: text.slice(cursor, start),
                isBold: false,
            });
        }

        if (end > start) {
            segments.push({
                text: text.slice(start, end),
                isBold: true,
            });
        }

        cursor = Math.max(cursor, end);
    });

    if (cursor < text.length) {
        segments.push({
            text: text.slice(cursor),
            isBold: false,
        });
    }

    return segments.length ? segments : [{ text, isBold: false }];
});
</script>
